import React, { useState, useEffect } from 'react'
import Pen from '../Pen/Pen'
import { Link } from 'react-router-dom';
import NavBar from '../NavBar/NavBar'
import firebase from 'firebase/app'
import { useSelector } from 'react-redux'
import blank_profile from '../../assets/img/blank_profile.png'
import Loader from '../Loader';

const LoadProfile = (props) => {
  const { is_loading } = useSelector(state => state.authReducer)

  return is_loading ? <Loader /> : <Profile props={props} />
}
const Profile = ({props}) => {

  const { user_data, is_logged_in } = useSelector(state => state.authReducer)
  const [state, setState] = useState({
    user: '',
    pens: [],
    currentPage: 0,
    userInfo: {},
    showcase: [],
    search: '',
    displayShowcase: false
  })

  const [ pen_loading, setLoading] = useState(true)

  const [pensData, setList] = useState([])

useEffect(() => {
  if(!is_logged_in)
    {
      window.location.hash = "/"
      return
  }
  firebase.firestore().collection("users").doc(user_data.uid)
  .get().then(snap => {
    if(snap.exists) {
      const data = snap.data()
      if(!data.pens) return
      data.pens.map(pen => {
        firebase.firestore().collection("pens").doc(pen)
        .get().then(penSnap => {
          if(penSnap.exists) {
            setList(prev => [...prev, penSnap.data()])
          }
        })
        .then(_ => setLoading(false))
      })
    }
  })
},[])
  let { userInfo } = state;
  const UserAvatar = () =>  <img className='avatar' src={user_data.photo_url ? user_data.photo_url  : blank_profile} alt='' /> 


const pensList = pensData.map(pen => {
    return (
        <Pen
            key={pen.pen_id}
            id={pen.pen_id}
            penData={pen}
            />
    );
})


const logoutUser = () => {
  var confirm = window.confirm("Confirm to logout?");
  if(!confirm) return
  firebase.auth().signOut()
  window.location.hash = "#/"
}

return(
      <div>
        <NavBar />
        <div className='Content'>
          <div className='grayLine'>
          </div>

          <div className='b-line'>
            <div className='followers'>
              {/* <h1> 0 Followers</h1>
              <h1 className='followers'> 0 Following</h1> */}
            </div>
            {userInfo ?
              <div className="links">
                {userInfo.link1 ? <a href={userInfo.link1} target="_blank">Profile Link {userInfo.link2 ? 1 : ""}</a> : null}
                {userInfo.link2 ? <a href={userInfo.link2} target="_blank">Profile Link 2</a> : null}
                {userInfo.link3 ? <a href={userInfo.link3} target="_blank">Profile Link 3</a> : null}
                <div onClick={() => logoutUser()} className='Hire'>Logout</div>
              </div>
              : null}
          </div>

          <Link className='link' to="/account">
            <div className='EditP'>
              <h1 onClick={() => props.history.push('/account')}>Edit Profile</h1>
            </div>
          </Link>
          <div className='UserInfo'>
            <div>
              <h1 className='UserName'></h1>
              <div id='UserPic'>
                {UserAvatar()}
              </div>
              <p id='Name2'>@{user_data ? user_data.name : ''}</p>
              { user_data.location && <h3><i className="fa fa-map-marker mr-2 text-gray-600"></i>{user_data.location}</h3> }
              { user_data.bio && <h3><i className="fa fa-pencil mr-2 text-gray-600"></i>{user_data.bio}</h3> }
            </div>
          </div>
          <div className="profileContainer">
            <div className='Pen-InputWrapper'>
              <div>
                <h2 className={state.displayShowcase ? 'Pens2' : ' Pens2 link-active '}
                //  onClick={() => {
                //   state.displayShowcase ? toggleDisplayShowcase() : null
                //   getAllPens()
                // }} 
                >Your Pens</h2>
              </div>
            </div>
            {
              pen_loading ?
                <div className="mx-20">
                  <Loader />
                </div> 
                :
                <div>
                  <div className='ligthgray-line'></div>
                  <div className='gray-line'></div>
                </div>
            }
            <div className="pensDisplay">
                { pensList }
            </div>
          </div>
        </div>
      </div>
    )
  }

export default LoadProfile;


// WEBPACK FOOTER //
// ./src/components/Account/Profile.js